import { render, staticRenderFns } from "./UpdateAdAccountModal.vue?vue&type=template&id=512b3d3e"
import script from "./UpdateAdAccountModal.vue?vue&type=script&lang=js"
export * from "./UpdateAdAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports